import styled, { css } from "styled-components";

export const Pagination = styled.ul`
  display: flex;
  margin-top: 30px;
  flex-wrap: wrap;
`;

export const Page = styled.li`

  a {
    background-color: #c4c4c4;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #fff;
    margin-right: 5px;
    text-decoration: none;
    margin-bottom: 8px;

`;

export const PageSimple = styled.li`
  ${props =>
    props.firstPage &&
    css`
      &:first-child a {
        background-color: #343434;
      }
    `};

  a {
    background-color: #c4c4c4;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #fff;
    margin-right: 5px;
    text-decoration: none;
    margin-bottom: 8px;

    ${props =>
      props.currentPage &&
      css`
        background-color: #343434;
      `} &:hover {
      background-color: #343434;
    }
  }
`;
